import { LOCALE } from '@stores/localeWeight';
import { AccountFilter } from '@pages/PromotionPage/Activity/PromotionActivityEditModal/PromotionActivityEditModal.types';

export enum PromotionActivityStatus {
  ACTIVE = 'active',
  PLANNED = 'planned',
  ENDED = 'ended',
  ERROR = 'error',
}

export default interface tagGame {
  id: number;
  name: string;
}

export interface IPromotionActivity {
  id: number;
  name: string;
  starts: string;
  ends: string;
  textL18n: string;
  status: PromotionActivityStatus;

  postDto: {
    id: number;
    link: string;
    game?: { name: string; id: number };
    files: Array<{
      image: {
        url: string;
      };
    }>;
  };
  filter: {
    gameIds: number[];
    ids: number[];
    languages: LOCALE | null;
    locales: LOCALE | 'all' | null | any
    games: tagGame[];
  };
}

export interface IPromotionActivityAction {
  id?: number;
  name: string;
  postId: string;
  starts?: string;
  ends?: string;
  gameIds?: number[];
  accountFilter?: AccountFilter;
  textL18nKey?: string; // строка для запроса на создание промо
}
